import dayjs from "dayjs";

/**
 * Calculate the VAT price of a total price
 * @param {*} price
 * @param {*} taxRate
 * @returns
 */
export const calculateVat = (price, taxRate) => {
  return Math.round((price / (100 + taxRate)) * taxRate * 100) / 100;
};

export const weekdaysBetween = (d1, d2, isoWeekday) => {
  // ensure we have valid dayjs instances
  d1 = dayjs.unix(d1);
  d2 = dayjs.unix(d2);
  // figure out how many days to advance to get to the next
  // specified weekday (might be 0 if d1 is already the
  // specified weekday).
  let daysToAdd = (7 + isoWeekday - d1.isoWeekday()) % 7;
  let nextTuesday = d1.clone().add(daysToAdd, "days");
  // if we are already passed the end date, there must not
  // be any of that day in the given period.
  if (nextTuesday.isAfter(d2)) {
    return 0;
  }
  // otherwise, just return the whole number of weeks
  // difference plus one for the day we already advanced to
  let weeksBetween = d2.diff(nextTuesday, "weeks");
  return weeksBetween + 1;
};

export const getPackingDateFromDeliveryDate = (deliveryDate) => {
  return dayjs(deliveryDate).subtract(1, "day");
};

export const getPackingDateId = (deliveryDate) => {
  return getPackingDateFromDeliveryDate(deliveryDate).format("DDMMYYYY");
};
